import DocumentationButton from "components/DocumentationButton";
import DrawerBody from "ds/components/Drawer/Body";
import DrawerFooter from "ds/components/Drawer/Footer";
import DrawerHeader from "ds/components/Drawer/Header";
import DrawerCloseIcon from "ds/components/DrawerNew/CloseIcon";
import DrawerHeaderTitle from "ds/components/DrawerNew/HeaderTitle";
import DrawerSimple from "ds/components/DrawerNew/Simple";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import Typography from "ds/components/Typography";
import { AnalyticsPageOrganization } from "hooks/useAnalytics/pages/organization";
import { getDocsUrl } from "utils/getDocsUrl";

const ApiKeysInfoDrawer = createDrawer(() => {
  return (
    <DrawerSimple isDismissable>
      <DrawerHeader justify="between">
        <DrawerHeaderTitle title="API keys" />
        <DrawerCloseIcon />
      </DrawerHeader>
      <DrawerBody fullHeight>
        <Typography tag="p" variant="p-body2">
          API keys are unique credentials used to authenticate and authorize access to Spacelift's
          GraphQL API. They secure automation and integrations by defining the actions an API client
          can perform exactly.
          <br />
          <br />
          You can assign system or custom roles to each key, determining its permissions across
          selected Spaces.
          <br />
          <br />
          You can update roles, or simply delete or replace keys.
          <br />
          <br />
          API key access can also be managed at the group level, depending on your identity
          management strategy:
          <ul>
            <li>
              If you're using Identity Access Management (IAM) via an IdP (like Okta or Azure AD),
              assign API keys to IdP groups, either during creation or after.
            </li>
            <li>
              Group strings need to be added in the UI and also if you're using Login policies.
            </li>
          </ul>
          This allows consistent, centralized access control for service accounts and automation
          across teams.
        </Typography>
        <DrawerFooter>
          {/** TODO: update docs link once we have updated documentation */}
          <DocumentationButton
            label="Documentation"
            to={getDocsUrl("/integrations/api#authenticating-with-the-graphql-api")}
            analyticsPage={AnalyticsPageOrganization.OrganizationApiKeys}
          />
        </DrawerFooter>
      </DrawerBody>
    </DrawerSimple>
  );
});

export const showApiKeysInfoDrawer = createDrawerTrigger(ApiKeysInfoDrawer);
